// extracted by mini-css-extract-plugin
export var animationContainer = "_p8-0";
export var footer = "_p8-1";
export var gray = "_p8-2";
export var lineItem = "_p8-3";
export var lineItemImage = "_p8-4";
export var lineItemInfo = "_p8-5";
export var lineItemText = "_p8-6";
export var lineItems = "_p8-7";
export var modalContent = "_p8-8";
export var options = "_p8-9";
export var orderName = "_p8-a";
export var refundAmount = "_p8-b";